import axiosInstance from "../utils/axios"
// import { handleApiError } from "../utils/errorHandler"

export const ratePerParameterService = {
    fetchAll: async (params = {}) => {
      const response = await axiosInstance.get('/rate-per-parameter/paginate', {
        params,
      })
      return response.data
    },
    getById: async (id) => {
      const response = await axiosInstance.get('/rate-per-parameter/' + id)
      return response.data
    },
    store: async (data) => {
      const response = await axiosInstance.post('/rate-per-parameter', data)
      return response.data
    },
    update: async (data) => {
      const response = await axiosInstance.put(`/rate-per-parameter/${data.id}`, data)
      return response.data
    },
    delete: async (id) => {
      const response = await axiosInstance.delete(`/rate-per-parameter/${id}`)
      return response.data
    },
}